import { gql } from '@apollo/client'
import meetingCoreFragment from './fragments/meetingCore.fragment'
import meetingRestFragment from './fragments/meetingRest.fragment'

export const UPDATE_MEETING_STEP = gql`
  mutation UpdateMeetingStep($id: HashedId!, $newStepStatus: MeetingStepStatus!) {
    updateMeetingStep(id: $id, newStepStatus: $newStepStatus) {
      id
      status
    }
  }
`

export const SET_ACTIVE_MEETING_STEP = gql`
  mutation SetNextMeetingStep($id: HashedId!, $nextStepId: HashedId!, $currentStepStatus: MeetingStepStatus, $stepType: MeetingStepType!) {
    setNextMeetingStep(id: $id, nextStepId: $nextStepId, currentStepStatus: $currentStepStatus, stepType: $stepType) {
      id
      date
      meetingSteps {
        id
        viewId
        status
        position
      }
      activeMeetingStep {
        id
        viewId
      }
      employeePreparationActiveStep {
        id
        viewId
      }
      managerPreparationActiveStep {
        id
        viewId
      }
    }
  }
`

export const UPDATE_MEETING_FEEDBACK = gql`
  mutation UpdateMeetingFeedback($meetingId: HashedId!, $feedback: String!) {
    updateMeetingFeedback(meetingId: $meetingId, feedback: $feedback) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`

export const MANAGER_CLOSE_MEETING = gql`
  mutation ManagerCloseMeeting($meetingInput: ManagerCloseMeetingInput!) {
    managerCloseMeeting(closeMeetingInput: $meetingInput) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`

export const EMPLOYEE_CLOSE_MEETING = gql`
  mutation EmployeeCloseMeeting($meetingInput: EmployeeCloseMeetingInput!) {
    employeeCloseMeeting(closeMeetingInput: $meetingInput) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`

export const MANAGER_FORCE_MEETING_CONFIRMATION = gql`
  mutation ManagerForceMeetingConfirmation($meetingId: HashedId!, $reason: String!) {
    managerForceMeetingConfirmation(meetingId: $meetingId, reason: $reason)
  }
`

export const CANCEL_MEETING = gql`
  mutation CancelMeeting($meetingId: HashedId!, $employeeId: HashedId!, $reasonForMeetingCancel: String!) {
    cancelMeeting(meetingId: $meetingId, employeeId: $employeeId, reasonForMeetingCancel: $reasonForMeetingCancel)
  }
`

export const OTHER_MEETING_CONFIRM_AS_MANAGER = gql`
  mutation OtherMeetingConfirmAsManager($employeeId: HashedId!, $reviewerEmployeeId: HashedId!, $meetingId: HashedId!, $protocol: String!) {
    otherMeetingConfirmAsManager(
      employeeId: $employeeId
      reviewerEmployeeId: $reviewerEmployeeId
      meetingId: $meetingId
      protocol: $protocol
    ) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`

export const OTHER_MEETING_FINISH_PREPARATION = gql`
  mutation OtherMeetingFinishPreparation(
    $employeeId: HashedId!
    $reviewerEmployeeId: HashedId!
    $meetingId: HashedId!
    $notes: String!
    $asManager: Boolean!
  ) {
    otherMeetingFinishPreparation(
      employeeId: $employeeId
      reviewerEmployeeId: $reviewerEmployeeId
      meetingId: $meetingId
      notes: $notes
      asManager: $asManager
    ) {
      ...MeetingCore
      ...MeetingRest
    }
  }
  ${meetingCoreFragment}
  ${meetingRestFragment}
`

export const TAKE_OVER_MEETING = gql`
  mutation TakeOver($meetingId: HashedId!) {
    takeOver(meetingId: $meetingId) {
      ...MeetingCore
    }
  }
  ${meetingCoreFragment}
`

export const HR_MANAGE_MEETING = gql`
  mutation HrManageMeeting($hrManageMeetingInput: HrManageMeetingInput!) {
    hrManageMeeting(hrManageMeetingInput: $hrManageMeetingInput) {
      id
    }
  }
`

export const REQUEST_MEETING_AS_EMPLOYEE = gql`
  mutation RequestMeetingAsEmployee($meetingReason: String!, $meetingType: MeetingType!, $reviewerId: HashedId!, $requesterId: HashedId!) {
    requestMeetingAsEmployee(meetingReason: $meetingReason, meetingType: $meetingType, reviewerId: $reviewerId, requesterId: $requesterId) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
    }
  }
`

export const ACCEPT_REQUESTED_MEETING = gql`
  mutation AcceptRequestedMeeting($requestedMeetingId: HashedId!, $meetingInput: MeetingInviteInput!) {
    acceptRequestedMeeting(requestedMeetingId: $requestedMeetingId, meetingInput: $meetingInput) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
      meeting {
        id
        date
      }
    }
  }
`

export const DECLINE_REQUESTED_MEETING = gql`
  mutation DeclineRequestedMeeting($requestedMeetingId: HashedId!, $reasonOfRejection: String!) {
    declineRequestedMeeting(requestedMeetingId: $requestedMeetingId, reasonOfRejection: $reasonOfRejection) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
    }
  }
`

export const WITHDRAW_MEETING_REQUEST = gql`
  mutation WithdrawRequestedMeeting($employeeId: HashedId!, $requestId: HashedId!) {
    withdrawRequestedMeeting(employeeId: $employeeId, requestId: $requestId) {
      id
    }
  }
`
export const RESCHEDULE_MEETING = gql`
  mutation RescheduleMeeting($rescheduleInput: RescheduleMeetingInput!) {
    rescheduleMeeting(rescheduleInput: $rescheduleInput)
  }
`
export const UPDATE_MEETING_NOTES = gql`
  mutation UpdateMeetingNotes($meetingId: HashedId!, $notes: String!) {
    updateMeetingNotes(meetingId: $meetingId, notes: $notes)
  }
`
